<app-page-breadcrumb pageTitle="Segmentos"></app-page-breadcrumb>

<div class="flex items-center justify-end mb-6">

    <button type="button" *appHasPermission="'segments:create'" (click)="nuevoSegment()"
        class="px-4 py-2 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5 shadow-sm">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nuevo Segmento
    </button>
</div>

<app-folder-form-modal [isOpen]="isFolderModalOpen" [bussinesId]="businessId" (close)="closeFolderModal($event)">
</app-folder-form-modal>




<div class="space-y-6">

    <app-segment-stats class="block"
        [totalSegmentsCount]="totalSegmentsCount"
        [dynamicSegmentsCount]="dynamicSegmentsCount"
        [staticSegmentsCount]="staticSegmentsCount"
        [suppressedSegmentsCount]="suppressedSegmentsCount">
    </app-segment-stats>

    <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-2xl p-5 shadow-sm">
        
        <div class="flex items-center justify-between mb-4">
            <h3 class="flex items-center gap-2 text-gray-800 dark:text-gray-200 font-bold text-base">
                <svg class="w-5 h-5 text-gray-700 dark:text-gray-300" fill="currentColor" viewBox="0 0 20 20"><path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"></path></svg>
                Carpetas
            </h3>
            
            <button type="button" *appHasPermission="'segments:edit'" (click)="openFolderModal()"
                class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg>
                Nueva carpeta
            </button>
        </div>

        <div class="flex items-center gap-2 overflow-x-auto custom-scrollbar pb-1">
            <button (click)="setFolderFilter(null)"
                [ngClass]="selectedFolderId === null ? 'bg-brand-500 text-white hover:bg-brand-600' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'"
                class="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap shrink-0">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"></path></svg>
                Todas las listas
                <span class="px-2 py-0.5 rounded-full text-xs" [ngClass]="selectedFolderId === null ? 'bg-brand-600/50' : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400'">{{ totalSegmentsCount || 0 }}</span>
            </button>

            @for (folder of folders; track folder.id) {
            <div class="group flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap shrink-0"
                [ngClass]="selectedFolderId === folder.id ? 'bg-brand-500 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'"
                (click)="setFolderFilter(folder.id)">
                <svg class="w-4 h-4" [ngClass]="selectedFolderId === folder.id ? 'text-white' : 'text-gray-500'" fill="currentColor" viewBox="0 0 20 20"><path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"></path></svg>
                {{ folder.name }}
                <span class="px-2 py-0.5 rounded-full text-xs" [ngClass]="selectedFolderId === folder.id ? 'bg-white/20' : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400'">{{ folder.segmentCount || 0 }}</span>

                <div class="hidden group-hover:flex items-center gap-1 ml-1 pl-1 border-l" [ngClass]="selectedFolderId === folder.id ? 'border-white/30' : 'border-gray-300 dark:border-gray-600'">
                    <button *appHasPermission="'segments:edit'" (click)="editarCarpeta(folder); $event.stopPropagation()" class="p-0.5 hover:text-brand-500" [ngClass]="selectedFolderId === folder.id ? 'text-white/70' : 'text-gray-400'" title="Editar nombre"><svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg></button>
                    <button *appHasPermission="'segments:delete'" (click)="eliminarCarpeta(folder.id); $event.stopPropagation()" class="p-0.5 hover:text-red-600" [ngClass]="selectedFolderId === folder.id ? 'text-white/70' : 'text-gray-400'" title="Eliminar carpeta"><svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg></button>
                </div>
            </div>
            }
        </div>
    </div>

    <div class="flex flex-wrap justify-between items-center gap-3">
        <div class="flex flex-wrap items-center gap-2">
            <button (click)="setFilterType('ALL')"
                class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
                [class.bg-brand-500]="filterType === 'ALL'" [class.text-white]="filterType === 'ALL'"
                [class.bg-white]="filterType !== 'ALL'" [class.text-gray-600]="filterType !== 'ALL'" [class.dark:bg-gray-800]="filterType !== 'ALL'" [class.dark:text-gray-300]="filterType !== 'ALL'"
                [class.border]="filterType !== 'ALL'" [class.border-gray-300]="filterType !== 'ALL'" [class.dark:border-gray-600]="filterType !== 'ALL'" [class.hover:border-gray-400]="filterType !== 'ALL'">
                @if (filterType === 'ALL') {
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                }
                Todas
            </button>
            <button (click)="setFilterType('DYNAMIC')"
                class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
                [class.bg-brand-500]="filterType === 'DYNAMIC'" [class.text-white]="filterType === 'DYNAMIC'"
                [class.bg-white]="filterType !== 'DYNAMIC'" [class.text-gray-600]="filterType !== 'DYNAMIC'" [class.dark:bg-gray-800]="filterType !== 'DYNAMIC'" [class.dark:text-gray-300]="filterType !== 'DYNAMIC'"
                [class.border]="filterType !== 'DYNAMIC'" [class.border-gray-300]="filterType !== 'DYNAMIC'" [class.dark:border-gray-600]="filterType !== 'DYNAMIC'" [class.hover:border-gray-400]="filterType !== 'DYNAMIC'">
                @if (filterType === 'DYNAMIC') {
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                }
                Dinámicas
            </button>
            <button (click)="setFilterType('STATIC')"
                class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
                [class.bg-brand-500]="filterType === 'STATIC'" [class.text-white]="filterType === 'STATIC'"
                [class.bg-white]="filterType !== 'STATIC'" [class.text-gray-600]="filterType !== 'STATIC'" [class.dark:bg-gray-800]="filterType !== 'STATIC'" [class.dark:text-gray-300]="filterType !== 'STATIC'"
                [class.border]="filterType !== 'STATIC'" [class.border-gray-300]="filterType !== 'STATIC'" [class.dark:border-gray-600]="filterType !== 'STATIC'" [class.hover:border-gray-400]="filterType !== 'STATIC'">
                @if (filterType === 'STATIC') {
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                }
                Estáticas
            </button>
            <button (click)="setFilterType('ARCHIVED')"
                class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
                [class.bg-brand-500]="filterType === 'ARCHIVED'" [class.text-white]="filterType === 'ARCHIVED'"
                [class.bg-white]="filterType !== 'ARCHIVED'" [class.text-gray-600]="filterType !== 'ARCHIVED'" [class.dark:bg-gray-800]="filterType !== 'ARCHIVED'" [class.dark:text-gray-300]="filterType !== 'ARCHIVED'"
                [class.border]="filterType !== 'ARCHIVED'" [class.border-gray-300]="filterType !== 'ARCHIVED'" [class.dark:border-gray-600]="filterType !== 'ARCHIVED'" [class.hover:border-gray-400]="filterType !== 'ARCHIVED'">
                @if (filterType === 'ARCHIVED') {
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                }
                Archivadas
            </button>
        </div>

        <!-- Búsqueda -->
        <div class="flex items-center gap-2 px-3.5 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg min-w-[260px] max-w-sm">
            <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
            <input #searchInput type="text" placeholder="Buscar listas..." (input)="onSearchChange(searchInput.value)" [value]="searchTerm"
                class="flex-1 text-sm bg-transparent border-none outline-none text-gray-700 dark:text-white placeholder-gray-400">
        </div>
    </div>


    <app-segment-table
        [segments]="segments"
        [selectedIds]="selectedSegmentsIds"
        [isLoading]="isLoading"
        [page]="page"
        [totalPages]="totalPages"
        [totalElements]="totalElements"
        [pageSize]="size"
        [pageSizeOptions]="pageSizeOptions"
        (view)="verSegment($event)"
        (edit)="editarSegment($event)"
        (duplicate)="duplicarSegment($event)"
        (delete)="eliminarSegment($event)"
        (toggleSelection)="toggleSelection($event)"
        (toggleAll)="toggleAll($event)"
        (openMoveFolder)="openMoveFolderModal()"
        (bulkDelete)="eliminarSeleccionados()"
        (prevPage)="previousPage()"
        (nextPage)="nextPage()"
        (goToPage)="goToPage($event)"
        (pageSizeChange)="changePageSize($event)"
        (changeStatus)="cambiarEstado($event)">
    </app-segment-table>
</div>

<app-segment-detail-modal
    [isOpen]="isDetailModalOpen"
    [segment]="selectedSegment"
    (close)="closeDetailModal()"
    (edit)="editarSegment($event)"
    (memberCountChanged)="onMemberCountChanged($event)">
</app-segment-detail-modal>

@if (isMoveFolderModalOpen) {
<div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50" (click)="closeMoveFolderModal()">
    <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-md p-6" (click)="$event.stopPropagation()">
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Mover a carpeta</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">{{ selectedSegmentsIds.length }} segmento(s) seleccionado(s)</p>

        <div class="space-y-2 max-h-60 overflow-y-auto">
            <button (click)="moveFolderTargetId = null"
                [ngClass]="moveFolderTargetId === null ? 'border-brand-500 bg-brand-50 dark:bg-brand-900/20' : 'border-gray-200 dark:border-gray-700'"
                class="w-full flex items-center gap-3 px-4 py-3 rounded-xl border text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"></path></svg>
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Sin carpeta</span>
            </button>
            @for (folder of folders; track folder.id) {
            <button (click)="moveFolderTargetId = folder.id"
                [ngClass]="moveFolderTargetId === folder.id ? 'border-brand-500 bg-brand-50 dark:bg-brand-900/20' : 'border-gray-200 dark:border-gray-700'"
                class="w-full flex items-center gap-3 px-4 py-3 rounded-xl border text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800">
                <svg class="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20"><path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"></path></svg>
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ folder.name }}</span>
                <span class="ml-auto text-xs text-gray-400">{{ folder.segmentCount || 0 }}</span>
            </button>
            }
        </div>

        <div class="flex justify-end gap-3 mt-6">
            <button (click)="closeMoveFolderModal()" class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">Cancelar</button>
            <button [appDisableWithoutPermission]="'segments:edit'" (click)="moveSelectedToFolder()" class="px-4 py-2 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 transition-colors">Mover</button>
        </div>
    </div>
</div>
}

